import React from 'react';
import { Trans } from "react-i18next";
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
export default function EstimationValidationCancelled() {
    return (<div className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-lg shadow-lg p-12 text-center">
          <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle size={48} className="text-gray-400"/>
          </div>
          
          <h1 className="text-3xl font-light mb-4"><Trans i18nKey="estimationValidation.cancelled.ui.paiementAnnule"/></h1>
          
          <p className="text-gray-700 mb-8 font-light leading-relaxed"><Trans i18nKey="estimationValidation.cancelled.ui.vousAvezAnnuleLeProcessusDePaiementAucunMontant"/> </p>

          <div className="flex gap-4 justify-center">
            <Link to="/estimation" className="px-6 py-3 bg-black text-white rounded-sm hover:bg-gray-800 transition flex items-center gap-2">
              <ArrowLeft size={20}/><Trans i18nKey="estimationValidation.cancelled.ui.retourAuxEstimations"/> </Link>
          </div>
        </div>
      </div>
    </div>);
}
